import { ValidationSummary } from "devextreme-react/validation-summary";
import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useRef, useState } from "react";
import { Field } from "../../../../layouts";
import { AR, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { LoadPopupPanel } from "../../../../components";
import { TextBox } from "devextreme-react/text-box";
import { useConfirmChangeOrder } from "../api/confirm-change-order";

export default function ConfirmChangeOrderButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [isPopupVisible, setPopupVisibility] = useState(false);

	const projectNumberRef = useRef<TextBox>(null);

	const confirmChangeOrder = useConfirmChangeOrder(
		() => {
			setPopupVisibility(false);
			refetchOrder();
			showSuccessMessage("The change order has been confirmed");
		},
		(error) => showErrorMessage(error)
	)

	return (
		<>
			<Button elementAttr={{ 'data-testid': 'btn-confirm-change-order' }}
				text="Confirm Change Order"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) &&
					(order.details.businessFlowCode === "CTG" || order.details.businessFlowCode === "Online") &&
					(order.details.roTypeID !== ROType.CabinetMeasureOrder) &&
					(order.details.roTypeID !== ROType.CabinetInstallOrder)}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Confirm Change Order"
				width={500}
				height={250}
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: function () {
							setPopupVisibility(false);
						}
					}}
					widget="dxButton"
					location="after"
				/>
				<ValidationSummary validationGroup="confirmChangeOrderGroup"></ValidationSummary>
				<Field label="Project Number">
					<TextBox inputAttr={{ 'data-testid': 'project-number' }}
						className='required'
						ref={projectNumberRef}
					>
						<Validator validationGroup='confirmChangeOrderGroup'>
							<RequiredRule message={'Project Number is required'}></RequiredRule>
						</Validator>
					</TextBox>
				</Field>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Submit',
						validationGroup: 'confirmChangeOrderGroup',
						onClick: (e: any) => {
							if (e.validationGroup.validate().isValid) {
								confirmChangeOrder.mutate({
									retailOrderID: order.details.retailOrderID,
									projectNumber: projectNumberRef.current?.instance.option("value")!
								});
							}
						}
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Cancel',
						onClick: () => setPopupVisibility(false)
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<LoadPopupPanel visible={confirmChangeOrder.isLoading}></LoadPopupPanel>
			</Popup>
		</>
	)
}
